import { useLocation } from "react-router-dom";

export const useURLParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const getParam = (key) => searchParams.get(key);

  const getAllParams = () => {
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const buildURLWithParams = (basePath, additionalParams = {}) => {
    const currentParams = getAllParams();
    const allParams = { ...currentParams, ...additionalParams };

    const paramString = new URLSearchParams(allParams).toString();
    return paramString ? `${basePath}?${paramString}` : basePath;
  };

  return {
    getParam,
    getAllParams,
    buildURLWithParams,
  };
};
